import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "inc_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API });

const isAuthEntry = (url = "") =>
  url.includes("/auth/login") || url.includes("/auth/register");

// Attach the token to requests — but NEVER to login/register, so a stale/invalid
// token from an older session can't interfere with signing in.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token && !isAuthEntry(config.url)) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// If any request comes back 401 with an invalid/expired token, drop it so the
// app never gets stuck in a half-logged-in state (e.g. after a security update).
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !isAuthEntry(url)) {
      clearToken();
    }
    return Promise.reject(err);
  }
);

export default api;
